import $ from 'jquery';

$('.js-scroll-below').on('click', function ScrollBelow(e) {
    e.preventDefault();

    const $this = $(this);
    const $main = $('html, body');
    const $elScrollTo = $('.' + $this.data('scroll-to'));
    const top = $elScrollTo.offset().top - 33;
    const topMob = $elScrollTo.offset().top - 93;

    if($(window).width() >= '768') {
        $main.animate({
            scrollTop: top
        }, 1000);
    }else {
        $main.animate({
            scrollTop: topMob
        }, 1000);
    }
});

$(window).on("load", function() {
    var hash = window.location.href.slice(window.location.href.indexOf('?') + 1).split('=');
    if(hash.length > 1) {
        $('html, body').animate({
            scrollTop: $('#'+hash[1]).offset().top
        }, 2000);
    }
});
